export default class BaseMapLegend {
    private map;
     
    /**
     * 
     * @param map 
     */
    constructor(map) {
        this.map = map;

        // query is optional. if specified, must pass cachedDatasets (string array)
        this.initClickHandler();
    }

    /**
     * 
     */
    private initClickHandler() {
        $('#trafficToggle').on('click', () => {
            es.util.TrackingEvents.push(['VM.Legend.Toggle_Traffic']);

            const isTrafficEnabled = this.map.baseMap.map.getTraffic().flow !== "none";
            if (isTrafficEnabled) {
                this.map.baseMap.map.setTraffic({incidents: false, flow: "none"});
            } else {
                this.map.baseMap.map.setTraffic({incidents: true, flow: "relative"});
            }
        });

        $('#satelliteToggle').on('click', () => {
            es.util.TrackingEvents.push(['VM.Legend.Weather_Satellite']);

            let weatherLayer = this.map.baseMap.getWeatherLayer();
            weatherLayer.updateLayerType("satellite");
            weatherLayer.show();

            this.map.eventChannel.fireEvent("onSetWeatherOverlay", "satellite");
        });

        $('#radarToggle').on('click', () => {
            es.util.TrackingEvents.push(['VM.Legend.Weather_Radar']);

            let weatherLayer = this.map.baseMap.getWeatherLayer();
            weatherLayer.updateLayerType("radar");
            weatherLayer.show();

            this.map.eventChannel.fireEvent("onSetWeatherOverlay", "radar");
        });

        $('#weatherOffToggle').on('click', () => {
            es.util.TrackingEvents.push(['VM.Legend.Weather_Off']);

            let weatherLayer = this.map.baseMap.getWeatherLayer();
            weatherLayer.hide();

            this.map.eventChannel.fireEvent("onSetWeatherOverlay", null);
        });

        const weatherDropdown = $("#legend-weather-dropdown-toggle");
        weatherDropdown.on("show", () => {
            // Reposition dropdown if it is too far down
            const weatherDropdownOffset = weatherDropdown.offset();
            weatherDropdown.css("top", $(window).height() < weatherDropdownOffset.top + 145 ? weatherDropdownOffset.top - 150 : weatherDropdownOffset.top);
            let weatherLayer = this.map.baseMap.getWeatherLayer();

            weatherDropdown.find(".legend-basemap-weather-option").removeClass("selected");
            if (!weatherLayer || !weatherLayer.isVisible()) {
                weatherDropdown.find("#weatherOffToggle").addClass("selected");
                return;
            }

            if (weatherLayer.getLayerType() === "radar") {
                weatherDropdown.find("#radarToggle").addClass("selected");
            } else {
                weatherDropdown.find("#satelliteToggle").addClass("selected");
            }
        });

        $('.legend-panel-basemap-link').on('click', (evt) => {
            evt.preventDefault();

            this.initPanel();
            const popup = $('#baseMapPopup');
            const basemapLink_top = $('.legend-panel-basemap').position().top;
            if( popup.css('display') != 'none') {
                popup.css('display', 'none');
            } else {
                const popupTop = basemapLink_top - popup.height() + $('.legend-panel-basemap').height() + 1;
                popup.css({position: 'absolute', top: popupTop, display: 'block'});

                if (popup.hasClass('smallScreen')) {
                    // Embedded / narrow public map. The popup is anchored inside the narrow
                    // right-hand legend panel, to right-anchor the  close btn
                    const margin = 8;
                    const offsetParent = popup[0].offsetParent;
                    const offsetParentLeft = offsetParent ? offsetParent.getBoundingClientRect().left : 0;
                    popup.css({
                        left: (margin - offsetParentLeft) + 'px',
                        right: 'auto',
                        width: $(window).width() - 2 * margin
                    });
                    $('.basemap-popup-wrap').css({width: 'auto', maxWidth: '100%'});
                    $('#baseMapPanel').css({maxWidth: '100%'});
                } else {
                    // Desktop: open into the map area to the left of the legend. Clear any
                    // width/left left over from a previous small-screen open.
                    popup.css({left: 'auto', right: 245, width: ''});
                    $('.basemap-popup-wrap').css({width: '', maxWidth: ''});
                    $('#baseMapPanel').css({maxWidth: ''});
                }

                $("#baseMapPanel .basemap-popup-icon").removeClass('selected');

                let el = null;
                if (this.map.baseMap.getStyleId() != null) {
                    el = $("#style_" + this.map.baseMap.getStyleId());
                } else {
                    el = $("#basemap-popup-" + this.map.baseMap.getType()).find("div." + this.map.baseMap.getType());
                }
                el.addClass("selected");

                $("#baseMapPanel").scrollLeft($("#baseMapPanel").position().left); //reset horizontal scroll
                $("#baseMapPanel").scrollLeft(el.position().left - 7); // scroll to the selected basemap
            }
        });
    }

    /**
     * 
     */
    private initPanel() {
        const baseMaps = this.getBaseMaps();

        var baseMapPopup = $('#baseMapPopup');
        baseMapPopup.empty();
        baseMapPopup.html(baseMaps);

        const baseMapPanel = $("#baseMapPanel");

        const freeMapWidth = $('#map-wrapper').width() - $('#legendPanel').width() - 30;
        const basemapWidth = baseMapPopup.width();
        // The 'smallScreen' class flags the embedded / narrow public map, where the basemap
        // popup must be re-fitted to the viewport when it opens (see the click handler). The
        // actual left/width positioning is done there so it can measure the offset parent.
        if ($('body').hasClass('publicApp') && basemapWidth >= freeMapWidth) {
            baseMapPopup.addClass('smallScreen');
        } else {
            baseMapPopup.removeClass('smallScreen');
        }

        baseMapPanel.find(".icon-x").on('click', function() {
            baseMapPopup.css('display', 'none');
        });

        // Base Map type selected
        baseMapPanel.find("li.basemap-popup-basemap div.basemap-popup-icon").on('click', (e) => {
            const basemap = $(e.target).attr("id");
            // basemap can be null if user clicks part of the panel that isnt the label
            if (basemap != null) {
                this.map.baseMap.setType(basemap);
                $("#baseMapPanel .basemap-popup-icon").removeClass('selected');
                $(e.target).addClass('selected');

                es.util.TrackingEvents.push(['VM.Legend.Change_Base_Map_' + basemap]);
            }
        });

        // Custom style selected
        baseMapPanel.find("li#basemap-popup-custom-style .basemap-popup-icon*").on('click', (e) => {
            let baseMapStyleId = +$(e.target).attr("id").replaceAll("style_", "");
            this.map.baseMap.setStyleById(baseMapStyleId);
            $("#baseMapPanel .basemap-popup-icon").removeClass('selected');
            $(e.target).addClass('selected');

            es.util.TrackingEvents.push(['VM.Legend.Change_Base_Map_Style_' + baseMapStyleId]);
        });
    }

    private getBaseMaps() {
        const baseMapTypes = this.map.baseMap.getBaseMapTypes();
        const baseMapCustomStyles = this.map.baseMap.getBaseMapCustomStylesObjRef();

        const defaultBaseMaps = $(
            '<div class="basemap-popup-wrap">' +
            '<div id="baseMapPanel" class="basemap-popup">' +
            '<div class="icon-x" id="es-basemap-close-x"></div>' +
            '<ul class="overview"> </ul>' +
            '</div>' +
            '</div>');

        for (let i = 0; i < baseMapTypes.length; i++) {
            const type = baseMapTypes[i];
            const i18nKey = '_Base_Map_' + type.charAt(0).toUpperCase() + type.slice(1);
            const element = $(
                '<li id="basemap-popup-' + type + '"  class="basemap-popup-basemap">' +
                '<div id="' + type + '" class="basemap-popup-icon azure ' + type + '"></div>' +
                '<div id="basemap-popup-text-' + type + '" class="basemap_name">' + $i18n(i18nKey) + '</div>' +
                '</li>'
            );
            defaultBaseMaps.find('ul.overview').append(element);
        }

        for (let j = 0; j < baseMapCustomStyles.length; j++) {
            const customStyle = baseMapCustomStyles[j];
            const element = $(
                '<li id="basemap-popup-custom-style">' +
                '<div id="style_' + customStyle.id + '" class="basemap-popup-icon azure ' + customStyle.name + '"></div>' +
                '<div id="basemap-popup-text-' + customStyle.name + '" class="basemap_name">' + customStyle.label + '</div>' +
                '</li>'
            );
            defaultBaseMaps.find('ul.overview').append(element);
        }
        
        return defaultBaseMaps;
    }
}
